import { createSlice } from '@reduxjs/toolkit';

const aiMessagesSlice = createSlice({
  name: 'aiMessages',
  initialState: {
    messages: [],
  },
  reducers: {
    setAiMessage: (state, action) => {
      const newMessage = { ...action.payload };
      if (newMessage.ts instanceof Date) {
        newMessage.ts = newMessage.ts.toISOString(); // Serialize Date to string
      }
      state.messages.push(newMessage);
    },
    // ✅ Add this
    updateAiMessage: (state, action) => {
        const index = state.messages.findIndex(m => m.id === action.payload.id);
        if (index !== -1) {
        state.messages[index] = { ...state.messages[index], ...action.payload };
        }
    },

    // ✅ Add this - mirrors old filter logic on error
    removeAiMessage: (state, action) => {
        state.messages = state.messages.filter(m => m.id !== action.payload.id);
    },

    clearAiMessages: (state) => {
      state.messages = []; // Clear all messages
    },
  },
});

export const { setAiMessage, clearAiMessages ,updateAiMessage , removeAiMessage } = aiMessagesSlice.actions;
export default aiMessagesSlice.reducer;